import BottomSheet from '@gorhom/bottom-sheet';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EarnStackParamList } from '@/features/earn';
import { getEarnCategoryTranslationKey } from '@/features/earn/utils/getEarnCategoryTranslationKey';
import { BottomSheetFilterOptionItem, BottomSheetFilterProps, BottomSheetFilterValues } from '../BottomSheetFilter';

export interface useListNativeProps {
  status: Array<BottomSheetFilterOptionItem>;
  defaultValues?: BottomSheetFilterValues;
}

const FILTER_NAME = 'status';

export const useListNative = (props: useListNativeProps) => {
  const { status, defaultValues = {} } = props;
  const earnNavigation = useNavigation<NativeStackNavigationProp<EarnStackParamList>>();
  const bottomSheetRef = useRef<BottomSheet>(null);
  const { t } = useTranslation('card-account');

  const onClose = () => {
    earnNavigation.goBack();
  };

  const [filters, setFilters] = useState<BottomSheetFilterValues>(defaultValues);
  const filterNumbers = filters[FILTER_NAME]?.length || 0;

  const bottomSheetFilterProps: BottomSheetFilterProps = {
    title: t('card-account::landing-page.text--filter'),
    bottomSheetRef,
    options: [
      {
        label: t('card-account::landing-page.text--card-type'),
        name: FILTER_NAME,
        options: status,
        singleSelect: true
      }
    ],
    values: filters,
    filteringNumber: filterNumbers,
    onClose,
    onChange: (tempFilters) => {
      setFilters(tempFilters);
    }
  };

  return {
    bottomSheetRef,
    filters,
    bottomSheetFilterProps
  };
};
